// Certificados SCS Indoor Advantage Gold. En WordPress no están vinculados a modelos ni a categorías:
// el de Tables se muestra en las categorías de mesas y mesas bajas, y el de Seating en todas las demás.
const SCS_TABLES_SLUG = 'apvc-certificates-scs-indoor-advantage-gold-tables';
const SCS_SEATING_SLUG = 'apvc-certificates-scs-indoor-advantage-gold-seating';

// Slugs de las categorías "Tables" y "Low Tables" en cada idioma (WPML crea un término distinto por idioma)
const TABLES_CATEGORY_SLUGS = [
  'tables', 'mesas', 'tables-fr', 'tische', 'tavoli',
  'low-tables', 'mesas-auxiliares', 'tables-basses', 'beistelltische', 'tavolini',
];

// Categorías sin certificado: Outdoor y Accessories
const NO_SCS_CATEGORY_SLUGS = [
  'outdoor',
  'accessories', 'accesorios', 'accessoires', 'accessoires-de', 'accessori',
];

export const isScsCertificate = (resource) =>
  [SCS_TABLES_SLUG, SCS_SEATING_SLUG].includes(resource.slug);

// Devuelve el slug del SCS que corresponde a una categoría, o null si no lleva ninguno
export const getScsCertificateSlug = (categorySlug) => {
  if (NO_SCS_CATEGORY_SLUGS.includes(categorySlug)) return null;
  return TABLES_CATEGORY_SLUGS.includes(categorySlug) ? SCS_TABLES_SLUG : SCS_SEATING_SLUG;
};
